import * as Sentry from "@sentry/angular";
import {
  ApplicationConfig,
  ErrorHandler,
  inject,
  isDevMode,
  provideAppInitializer,
  provideZoneChangeDetection,
} from '@angular/core';
import {
  provideRouter,
  Router,
  TitleStrategy,
  withEnabledBlockingInitialNavigation,
  withInMemoryScrolling
} from '@angular/router';
import { appRoutes } from './app.routes';
import { providePrimeNG } from 'primeng/config';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideHttpClient, withFetch, withInterceptors } from "@angular/common/http";
import { provideIndexedDb } from "ngx-indexed-db";
import { dbConfig } from "./core/services/storage/indexed-db/oskarudb/db-config";
import { MessageService } from "primeng/api";
import { authInterceptor } from "./core/auth/interceptors/auth-interceptor";
import { errorInterceptor } from "./core/error-handling/error-interceptor";
import { provideServiceWorker } from '@angular/service-worker';
import { OskaruTitleStrategy } from "./core/layout/oskaru-title-strategy";
import { LayoutService } from "./core/layout/service/layout.service";
import { provideCharts, withDefaultRegisterables } from 'ng2-charts';


export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(
      appRoutes,
      withInMemoryScrolling(
        { anchorScrolling: 'enabled', scrollPositionRestoration: 'enabled' }
      ),
      withEnabledBlockingInitialNavigation()
    ),
    provideHttpClient(
      withFetch(),
      withInterceptors([
        authInterceptor,
        errorInterceptor,
      ]),
    ),
    provideAnimationsAsync(),
    providePrimeNG({ theme: LayoutService.getThemeType() }),
    provideZoneChangeDetection({eventCoalescing: true}),
    provideIndexedDb(dbConfig),
    MessageService,
    provideServiceWorker('ngsw-worker.js', {
      enabled: !isDevMode(),
      registrationStrategy: 'registerWhenStable:30000'
    }),
    {
      provide: TitleStrategy,
      useClass: OskaruTitleStrategy
    },
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler()
    },
    {
      provide: Sentry.TraceService,
      deps: [Router]
    },
    provideAppInitializer(() => {
      inject(Sentry.TraceService);
    }),
    // ToDo: only import/register the chart.js modules that are really needed (tree shaking)
    provideCharts(withDefaultRegisterables()),
  ],
};
